module.exports = __webpack_public_path__ + "static/media/little-girl.39a4507f.png";